import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import "./styles/Schedule.css";

const backendUrl = "https://sokonishushi.co.tz/api";

export default function Schedule() {
    const [schedules, setSchedules] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editingSchedule, setEditingSchedule] = useState(null);
    const [showStaffDropdown, setShowStaffDropdown] = useState(false);
    const [formData, setFormData] = useState({
        staff_id: "",
        staff_names: "",
        staff_phonenumber: "",
        staff_role: "",
        shift_date: "",
        day: ""
    });

    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchSchedules();
        // Load all staff initially for dropdown
        fetchStaff("");
    }, []);

    const fetchSchedules = async () => {
        try {
            const response = await fetch(`${backendUrl}/schedule.php`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            const data = await response.json();
            if (data.success && data.schedules) {
                setSchedules(data.schedules);
            } else {
                setSchedules([]);
            }
        } catch (error) {
            console.error("Error fetching schedules:", error);
            setSchedules([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchStaff = async (search = "") => {
        try {
            console.log("Fetching staff with search:", search);
            const response = await fetch(`${backendUrl}/get_staff_for_schedule.php?search=${encodeURIComponent(search)}`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            const data = await response.json();
            console.log("Staff API response:", data);
            
            if (data.success && data.staff) {
                setStaffList(data.staff);
                console.log("Staff list updated:", data.staff.length, "staff members");
            } else {
                setStaffList([]);
                console.log("No staff found or API error");
            }
        } catch (error) {
            console.error("Error fetching staff:", error);
            setStaffList([]);
        }
    };

    const handleStaffSearch = async (e) => {
        const value = e.target.value;
        setFormData({ ...formData, staff_names: value });
        setShowStaffDropdown(true);
        
        if (value.length > 0) {
            await fetchStaff(value);
        } else {
            await fetchStaff(""); // Load all staff when search is empty
        }
    };

    const selectStaff = (staff) => {
        console.log("Selected staff:", staff);
        setFormData({
            ...formData,
            staff_id: staff.id,
            staff_names: staff.names,
            staff_phonenumber: staff.phonenumber || 'N/A',
            staff_role: staff.role || 'staff'
        });
        setShowStaffDropdown(false);
    };

    const getDayFromDate = (date) => {
        if (!date) return '';
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const d = new Date(date);
        return days[d.getDay()];
    };

    const handleDateChange = (e) => {
        const date = e.target.value;
        const day = getDayFromDate(date);
        setFormData({ ...formData, shift_date: date, day });
    };

    const handleCreateSchedule = async (e) => {
        e.preventDefault();
        
        if (!formData.staff_id) {
            Swal.fire({
                icon: 'error',
                title: 'Missing Staff',
                text: 'Please select a staff member from the dropdown',
                confirmButtonColor: '#6B5B95'
            });
            return;
        }
        
        if (!formData.shift_date) {
            Swal.fire({
                icon: 'error',
                title: 'Missing Date',
                text: 'Please select a shift date',
                confirmButtonColor: '#6B5B95'
            });
            return;
        }
        
        try {
            const response = await fetch(`${backendUrl}/schedule.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    staff_id: formData.staff_id,
                    shift_date: formData.shift_date,
                    day: formData.day
                })
            });
            const data = await response.json();
            if (data.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Schedule created successfully!',
                    confirmButtonColor: '#6B5B95',
                    timer: 2000
                });
                setShowModal(false);
                resetForm();
                fetchSchedules();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.error || 'Error creating schedule',
                    confirmButtonColor: '#6B5B95'
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Network error. Please try again.',
                confirmButtonColor: '#6B5B95'
            });
        }
    };

    const handleEditSchedule = (schedule) => {
        setEditingSchedule(schedule);
        setFormData({
            staff_id: schedule.staff_id,
            staff_names: schedule.names,
            staff_phonenumber: schedule.phonenumber || 'N/A',
            staff_role: schedule.role || 'staff',
            shift_date: schedule.shift_date,
            day: schedule.day
        });
        setShowModal(true);
    };

    const handleUpdateSchedule = async (e) => {
        e.preventDefault();
        
        if (!formData.shift_date || !formData.day) {
            Swal.fire({
                icon: 'error',
                title: 'Missing Fields',
                text: 'Please fill all required fields',
                confirmButtonColor: '#6B5B95'
            });
            return;
        }
        
        try {
            const response = await fetch(`${backendUrl}/schedule.php`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    id: editingSchedule.id,
                    shift_date: formData.shift_date,
                    day: formData.day
                })
            });
            const data = await response.json();
            if (data.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Schedule updated successfully!',
                    confirmButtonColor: '#6B5B95',
                    timer: 2000
                });
                setShowModal(false);
                resetForm();
                fetchSchedules();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.error || 'Error updating schedule',
                    confirmButtonColor: '#6B5B95'
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Network error. Please try again.',
                confirmButtonColor: '#6B5B95'
            });
        }
    };

    const handleDeleteSchedule = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#6B5B95',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
        
        if (result.isConfirmed) {
            try {
                const response = await fetch(`${backendUrl}/schedule.php`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ id })
                });
                const data = await response.json();
                if (data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Schedule deleted successfully!',
                        confirmButtonColor: '#6B5B95',
                        timer: 2000
                    });
                    fetchSchedules();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: data.error || 'Error deleting schedule',
                        confirmButtonColor: '#6B5B95'
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Network error. Please try again.',
                    confirmButtonColor: '#6B5B95'
                });
            }
        }
    };

    const resetForm = () => {
        setEditingSchedule(null);
        setFormData({
            staff_id: "",
            staff_names: "",
            staff_phonenumber: "",
            staff_role: "",
            shift_date: "",
            day: ""
        });
        setShowStaffDropdown(false);
    };

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/";
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading schedules...</p>
            </div>
        );
    }

    return (
        <div className="schedule-container">
            {/* Sidebar */}
            <aside className="schedule-sidebar">
                <div className="sidebar-brand">
                    <h2>AttendFlow</h2>
                </div>
                <div className="user-profile">
                    <div className="user-avatar">A</div>
                    <div className="user-details">
                        <span className="user-fullname">Admin</span>
                        <span className="user-badge admin">Admin</span>
                    </div>
                </div>
                <nav className="sidebar-menu">
                    <Link to="/dashboard" className="menu-item">
                        <span>📊</span> Dashboard
                    </Link>
                    <Link to="/admin-attendance" className="menu-item">
                        <span>📍</span> Attendance
                    </Link>
                    <Link to="/schedule" className="menu-item active">
                        <span>📅</span> Schedule
                    </Link>
                    <Link to="/reports" className="menu-item">
                        <span>📄</span> Reports
                    </Link>
                    <button onClick={handleLogout} className="menu-item logout">
                        <span>🚪</span> Logout
                    </button>
                </nav>
            </aside>

            {/* Main Content */}
            <main className="schedule-main-area">
                <div className="page-header">
                    <h1>Schedule Management</h1>
                    <p>Create and manage staff work schedules</p>
                </div>

                <div className="schedule-actions">
                    <button className="add-schedule-btn" onClick={() => {
                        resetForm();
                        setShowModal(true);
                        // Load all staff when modal opens
                        fetchStaff("");
                    }}>
                        + Add New Schedule
                    </button>
                </div>

                <div className="schedule-table-wrapper">
                    <table className="schedule-data-table">
                        <thead>
                            <tr>
                                <th>Staff Name</th>
                                <th>Phone Number</th>
                                <th>Role</th>
                                <th>Date</th>
                                <th>Day</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {schedules && schedules.length > 0 ? (
                                schedules.map((schedule) => (
                                    <tr key={schedule.id}>
                                        <td>{schedule.names || 'N/A'}</td>
                                        <td>{schedule.phonenumber || 'N/A'}</td>
                                        <td>
                                            <span className={`role-tag ${schedule.role || 'staff'}`}>
                                                {schedule.role || 'staff'}
                                            </span>
                                        </td>
                                        <td>{schedule.shift_date || 'N/A'}</td>
                                        <td>{schedule.day || 'N/A'}</td>
                                        <td className="action-cell">
                                            <button 
                                                className="edit-action"
                                                onClick={() => handleEditSchedule(schedule)}
                                            >
                                                Edit
                                            </button>
                                            <button 
                                                className="delete-action"
                                                onClick={() => handleDeleteSchedule(schedule.id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="empty-table">No schedules found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </main>

            {/* Modal */}
            {showModal && (
                <div className="modal-backdrop" onClick={() => {
                    setShowModal(false);
                    resetForm();
                }}>
                    <div className="modal-window" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-title">
                            <h3>{editingSchedule ? 'Edit Schedule' : 'Add New Schedule'}</h3>
                            <button className="modal-close" onClick={() => {
                                setShowModal(false);
                                resetForm();
                            }}>×</button>
                        </div>
                        <form onSubmit={editingSchedule ? handleUpdateSchedule : handleCreateSchedule}>
                            <div className="modal-field">
                                <label>Search Staff Member</label>
                                <div className="staff-search">
                                    <input
                                        type="text"
                                        required
                                        value={formData.staff_names}
                                        onChange={handleStaffSearch}
                                        onFocus={() => {
                                            setShowStaffDropdown(true);
                                            if (staffList.length === 0) {
                                                fetchStaff("");
                                            }
                                        }}
                                        placeholder="Type name or phone number to search..."
                                        disabled={!!editingSchedule}
                                        autoComplete="off"
                                    />
                                    {showStaffDropdown && staffList.length > 0 && !editingSchedule && (
                                        <div className="search-results">
                                            {staffList.map((staff) => (
                                                <div
                                                    key={staff.id}
                                                    className="search-result-item"
                                                    onClick={() => selectStaff(staff)}
                                                >
                                                    <div className="result-name">{staff.names}</div>
                                                    <div className="result-details">
                                                        📞 {staff.phonenumber} • 👤 {staff.role}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {showStaffDropdown && staffList.length === 0 && !editingSchedule && (
                                        <div className="search-results-empty">
                                            <div className="empty-message">No staff members found</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {formData.staff_id && !editingSchedule && (
                                <div className="modal-field auto-details">
                                    <label>Selected Staff</label>
                                    <div className="info-box">
                                        <p>✅ <strong>Name:</strong> {formData.staff_names}</p>
                                        <p>📞 <strong>Phone:</strong> {formData.staff_phonenumber}</p>
                                        <p>👤 <strong>Role:</strong> {formData.staff_role}</p>
                                    </div>
                                </div>
                            )}

                            <div className="modal-field">
                                <label>Select Shift Date</label>
                                <input
                                    type="date"
                                    required
                                    value={formData.shift_date}
                                    onChange={handleDateChange}
                                    min={new Date().toISOString().split('T')[0]}
                                />
                                <small className="field-hint">The day of week will be auto-calculated</small>
                            </div>

                            <div className="modal-field">
                                <label>Day of Week</label>
                                <input
                                    type="text"
                                    required
                                    value={formData.day}
                                    readOnly
                                    className="readonly-field"
                                    placeholder="Will auto-populate when date selected"
                                />
                            </div>

                            <div className="modal-actions">
                                <button type="button" className="cancel-action" onClick={() => {
                                    setShowModal(false);
                                    resetForm();
                                }}>Cancel</button>
                                <button type="submit" className="submit-action">
                                    {editingSchedule ? 'Update Schedule' : 'Create Schedule'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}